var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "button"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0175 14.3567C13.4042 14.6412 12.7206 14.8 12 14.8C9.34903 14.8 7.2 12.651 7.2 10C7.2 7.34903 9.34903 5.2 12 5.2C14.651 5.2 16.8 7.34903 16.8 10C16.8 11.4989 15.904 13.0824 15.0365 13.7176C14.169 14.3529 14.0148 14.3529 14.0148 14.3529C14.0148 14.3529 14.6309 14.0722 14.0175 14.3567ZM14.7342 15.3422C13.9143 15.7627 12.9849 16 12 16C8.68629 16 6 13.3137 6 10C6 6.68629 8.68629 4 12 4C15.3137 4 18 6.68629 18 10C18 11.8979 17.1188 13.59 15.7433 14.6894L18.9852 19.1471L18.0148 19.8529L14.7342 15.3422Z",
    fill: "#ADADAD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.97b5677edccdb4dcd0bed6c3994e3e99.svg";
export { ForwardRef as ReactComponent };